"use client";

import { createContext, ReactNode, useContext } from "react";

export type InitialSession = {
	email: string;
	firstName: string;
	lastName: string;
} | null;

type AuthContextType = {
	loading: boolean;
	isLoggedIn: boolean;
	email: string;
	accountName: string;
};

const AuthContext = createContext<AuthContextType>({
	loading: false,
	isLoggedIn: false,
	email: "",
	accountName: "",
});

const AuthProvider = ({
	children,
	initialSession,
}: {
	children: ReactNode;
	initialSession: InitialSession;
}) => {
	// Derive auth values directly from props on every render. Using useState
	// here would only read `initialSession` on the first mount, so the sidebar
	// would never update after login/logout when the root layout re-renders
	// with a new session.
	const isLoggedIn = !!initialSession;
	const email = initialSession?.email ?? "";
	const accountName = initialSession
		? `${initialSession.firstName} ${initialSession.lastName}`
		: "";

	return (
		<AuthContext.Provider
			value={{
				loading: false,
				isLoggedIn,
				email,
				accountName,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

const useAuth = () => useContext(AuthContext);

export { AuthContext, AuthProvider, useAuth };
